import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useTranslation } from "react-i18next";
import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material";
import TableBody from "@mui/material/TableBody";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import helpers from "../../../assets/js/helper";
import { toast } from "react-toastify";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import { useState } from "react";
import { useEffect } from "react";
import * as RiIcons from "react-icons/ri";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#1e6a99 !important",
    color: theme.palette.common.white,
    outerHeight: "30px !important",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
  "& td": {
    borderLeft: "0px",
    borderRight: "0px",
  },
  "& th": {
    padding: "0px !important",
  },
}));

export default function DetailsList(props) {
  const [copied, setCopied] = useState(false);
  const [copiedID, setCopiedID] = useState(null);
  const copyText = (row) => {
    setCopiedID(row?.id);
    const textToCopy =
      row?.vehicle_number ||
      (row?.vehicles && row?.vehicles?.map((v) => v?.name).join("\n")) ||
      "";

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          setCopied(true);
          toast.success("Text copied to clipboard");
        })
        .catch((err) => {
          console.error("Failed to copy text to clipboard:", err);
          fallbackCopyText(textToCopy); // Fallback mechanism
        });
    } else {
      fallbackCopyText(textToCopy); // Fallback mechanism
    }
  };

  const fallbackCopyText = (textToCopy) => {
    const textArea = document.createElement("textarea");
    textArea.value = textToCopy;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
    setCopied(true);
    toast.success("Text copied to clipboard");
  };

  useEffect(() => {
    let timer;
    if (copied) {
      timer = setTimeout(() => {
        setCopied(false);
      }, 1500);
    }

    return () => clearTimeout(timer);
  }, [copied]);

  return (
    <Box
      sx={{
        width: "100%",
        margin: "10px 20px 10px 10px",
        "& th": {
          padding: "5px 15px !important",
        },
        direction: "rtl",
      }}
    >
      {props?.exportFunction ? (
        <Tooltip title="download Excel" onClick={() => {}}>
          <IconButton
            aria-label="Create Task"
            style={{
              margin: 5,
              backgroundColor: "#e9e9e9",
              position: "absolute",
              top: 55,
              right: 20,
            }}
            id="fade-button"
            // aria-controls={openFilterColumn ? "fade-menu" : undefined}
            // aria-haspopup="true"
            // aria-expanded={openFilterColumn ? "true" : undefined}
            onClick={props?.exportFunction}
          >
            <RiIcons.RiDownloadCloudFill style={{ color: "#1e6a99" }} />
          </IconButton>
        </Tooltip>
      ) : null}
      <TableContainer>
        <Table
          sx={{ minWidth: "100%", direction: "rtl" }}
          aria-label="customized table"
        >
          <TableHead sx={{ height: "20px !important" }}>
            <TableRow sx={{ height: "20px !important" }}>
              <StyledTableCell align="right" sx={{ fontFamily: "Cairo-Bold" }}>
                <span style={{ fontFamily: "Cairo-Bold" }}>#</span>
              </StyledTableCell>
              <StyledTableCell align="right" sx={{ fontFamily: "Cairo-Bold" }}>
                <span style={{ fontFamily: "Cairo-Bold" }}>ارقام الوحدات</span>
              </StyledTableCell>
              <StyledTableCell align="right" sx={{ fontFamily: "Cairo-Bold" }}>
                <span style={{ fontFamily: "Cairo-Bold" }}>نوع العمل</span>
              </StyledTableCell>
              <StyledTableCell align="right" sx={{ fontFamily: "Cairo-Bold" }}>
                <span style={{ fontFamily: "Cairo-Bold" }}>تاريخ العمل</span>
              </StyledTableCell>
              {/* <StyledTableCell align="right" sx={{ fontFamily: "Cairo-Bold" }}>
                Serial Number
              </StyledTableCell> */}
              <StyledTableCell align="right" sx={{ fontFamily: "Cairo-Bold" }}>
                IMEI
              </StyledTableCell>
              <StyledTableCell align="right" sx={{ fontFamily: "Cairo-Bold" }}>
                نوع الجهاز
              </StyledTableCell>
              <StyledTableCell align="right" sx={{ fontFamily: "Cairo-Bold" }}>
                <span style={{ fontFamily: "Cairo-Bold" }}>حالة الجهاز</span>
              </StyledTableCell>
              <StyledTableCell align="right" sx={{ fontFamily: "Cairo-Bold" }}>
                ملاحظة
              </StyledTableCell>
              <StyledTableCell align="right" sx={{ fontFamily: "Cairo-Bold" }}>
                Qty
              </StyledTableCell>
              {props?.deleteDetails ? (
                <StyledTableCell
                  align="right"
                  sx={{ fontFamily: "Cairo-Bold" }}
                >
                  حذف
                </StyledTableCell>
              ) : null}
            </TableRow>
          </TableHead>
          <TableBody>
            {props?.list?.length > 0 ? (
              props?.list?.map((row) => (
                <StyledTableRow key={row.name}>
                  <StyledTableCell align="right" sx={{ fontFamily: "Cairo" }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "start",
                        flexDirection: "column",
                        fontWeight: "bold",
                      }}
                    >
                      {row?.id}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell align="right" sx={{ fontFamily: "Cairo" }}>
                    <Box
                      sx={{
                        position: "relative",
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "start",
                        flexDirection: "column",
                        minWidth: "160px",
                      }}
                    >
                      {row?.vehicle_number
                        ? row?.vehicle_number
                        : row?.vehicles && row?.vehicles?.length
                        ? row?.vehicles?.map((v, i) => (
                            <Typography
                              sx={{
                                fontWeight: "bold",
                                textAlign: "right",
                                fontSize: "14px",
                                // backgroundColor: "#d3d3d3",
                                padding: "3px",
                                borderRadius: "3px",
                                margin: "2px",
                                borderBottom:
                                  i !== row?.vehicles?.length - 1
                                    ? "1px solid #d3d3d3"
                                    : "",
                              }}
                            >
                              {i + 1}{"."}{" "}{v?.name}
                            </Typography>
                          ))
                        : null}
                      {copied && row?.id === copiedID ? (
                        <Tooltip placement="top" title={"تم نسخ النص"}>
                          <AssignmentTurnedInIcon
                            fontSize="14px"
                            sx={{
                              position: "absolute",
                              top: 5,
                              left: -15,
                              color: "#1e992c",
                              width: "20px",
                              height: "20px",
                              transition: "0.4s",
                            }}
                          />
                        </Tooltip>
                      ) : (
                        <Tooltip placement="top" title={"نسخ النص"}>
                          <AssignmentIcon
                            fontSize="14px"
                            sx={{
                              position: "absolute",
                              top: 5,
                              left: -15,
                              color: "#1e6a99",
                              width: "20px",
                              height: "20px",
                              transition: "0.4s",
                              ":hover": {
                                color: "#494949",
                                cursor: "pointer",
                              },
                            }}
                            onClick={() => copyText(row)}
                          />
                        </Tooltip>
                      )}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell align="right" sx={{ fontFamily: "Cairo" }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "start",
                        flexDirection: "column",
                        fontWeight: "bold",
                      }}
                    >
                      {row?.selectedWorkType?.name}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell align="right" sx={{ fontFamily: "Cairo" }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "start",
                        flexDirection: "column",
                        fontWeight: "bold",
                        width: "80px"
                      }}
                    >
                      {helpers.formatDate(row?.date)}
                    </Box>
                  </StyledTableCell>
                  {/* <StyledTableCell align="right" sx={{ fontFamily: "Cairo" }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "start",
                        flexDirection: "column",
                        fontWeight: "bold",
                      }}
                    >
                      {row.sn}
                    </Box>
                  </StyledTableCell> */}
                  <StyledTableCell align="right" sx={{ fontFamily: "Cairo" }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "start",
                        flexDirection: "column",
                        fontWeight: "bold",
                      }}
                    >
                      {row.IMEI
                        ? row?.IMEI
                        : row?.vehicles && row?.vehicles?.length
                        ? row?.vehicles?.map((v, i) => (
                            <Typography
                              sx={{
                                fontWeight: "bold",
                                textAlign: "right",
                                fontSize: "14px",
                                // backgroundColor: "#d3d3d3",
                                padding: "3px",
                                borderRadius: "3px",
                                margin: "2px",
                                borderBottom:
                                  i !== row?.vehicles?.length - 1
                                    ? "1px solid #d3d3d3"
                                    : "",
                                width: "160px"
                              }}
                            >
                              {i + 1}{"."}{" "}{v?.imei}
                            </Typography>
                          ))
                        : null}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell align="right" sx={{ fontFamily: "Cairo" }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "start",
                        flexDirection: "column",
                        fontWeight: "bold",
                      }}
                    >
                      {row.type
                        ? row.type
                        : row?.vehicles?.length && row?.vehicles?.every(v => v.device === row?.vehicles[0]?.device)
                        ? row?.vehicles[0]?.device
                        : null}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell align="right" sx={{ fontFamily: "Cairo" }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "start",
                        flexDirection: "column",
                        fontWeight: "bold",
                      }}
                    >
                      {row?.selectedDeviceStatus?.name}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell align="right" sx={{ fontFamily: "Cairo" }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "start",
                        flexDirection: "column",
                        fontWeight: "bold",
                        minWidth: "150px",
                      }}
                    >
                      {row.note}
                    </Box>
                  </StyledTableCell>
                  <StyledTableCell align="right" sx={{ fontFamily: "Cairo" }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "start",
                        flexDirection: "column",
                        fontWeight: "bold",
                      }}
                    >
                      {row.qty}
                    </Box>
                  </StyledTableCell>
                  {props?.deleteDetails ? (
                    <StyledTableCell align="right" sx={{ fontFamily: "Cairo" }}>
                      <RemoveCircleIcon
                        sx={{ color: "#f00", cursor: "pointer" }}
                        onClick={() => props?.deleteDetails(row?.id)}
                      />
                    </StyledTableCell>
                  ) : null}
                </StyledTableRow>
              ))
            ) : (
              <StyledTableCell component="th" scope="row" colSpan={8}>
                <Box
                  sx={{
                    fontFamily: "Cairo-Medium",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  لا يوجد تفاصيل
                </Box>
              </StyledTableCell>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
